import React from 'react';
import {
  Container,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './Experience.scss';

const Experience = () => {
  const experiences = [
    {
      title: 'Senior Software Engineer',
      company: "Moody's Investor Services",
      location: 'Charlotte, NC',
      period: 'March 2024 - Present',
      achievements: [
        'Spearheaded agentic workflow development for web apps using specialized SDKs, achieving full compliance and operational efficiency',
        'Developed RAG-based data retrieval and visualization, presenting precise, on-demand insights for user prompts',
        'Implemented data visualization in the user interface for statistical models on the MIS EPORT software application',
        'Engineered generic error messaging for failed model computations for the analysts to identify the root cause',
        'Architected .Net Core API\'s to aggregate and send data from complex model computations',
        'Resulted in 20 percent lower turnaround time for analysts to share feedback to the ratings committee'
      ]
    },
    {
      title: 'Research & Teaching Assistant',
      company: 'Binghamton University',
      location: 'Binghamton, NY',
      period: 'January 2023 - March 2024',
      achievements: [
        'Researching the Tip of the tongue problem to find a efficient solution using NLP techniques with python source code',
        'Instructed graduate students on Advanced Data structures and algorithms, Machine Learning and Data Mining courses',
        'Investigated the chore division problem aimed at making allocation of indivisible chores among agents envy free',
        'Programmed a linear program in .net core using gurobi optimizer to solve the problem'
      ]
    },
    {
      title: 'Computer Science Intern',
      company: 'Global Health Impact',
      location: 'Binghamton, NY',
      period: 'September 2022 - December 2022',
      achievements: [
        'Programmed user interface for global and regional health impact data analytics',
        'Engineered back-end API services using .Net framework, node js, python flask to feed data to the UI built on React js',
        'Architected nosql mongo database for the application',
        'Applied normalization techniques on the data set to get better insights from the plots',
        'Enforced peer reviews, pre check-in hooks using GIT to increase code quality and accelerated development timeline by 70%'
      ]
    },
    {
      title: 'Software Engineer',
      company: 'Rackspace Technology',
      location: 'Hyderabad, India',
      period: 'December 2020 - August 2022',
      achievements: [
        'Developed full-stack cloud-native applications for healthcare and e-commerce domains',
        'Engineered server less API\'s, single page web applications, message queues',
        'Enhanced Convatec software, cutting post-ostomy procedure communication bottle necks by 80%',
        'Revamped Aramex International\'s courier tracking system utlilizing AWS and Azure SaaS',
        'Maintained comprehensive test coverage, resulting in a 90% reduction in feature-related bugs'
      ]
    },
    {
      title: 'Software Engineer',
      company: 'Zenoti',
      location: 'Hyderabad, India',
      period: 'August 2020 - November 2020',
      achievements: [
        'Collaborated with product development to build UI components, back end services, integrations',
        'Implemented unified campaign, automated advertisements feature for the product',
        'Implemented API\'s in .Net core, Integrated with third party cloud native services, Expanded the store\'s reach by 90%',
        'Integrated ADP API\'s for pricing and salary calculation to reduce friction in human capital management'
      ]
    },
    {
      title: 'Software Engineer',
      company: 'Mindtree Limited',
      location: 'Bangalore, India',
      period: 'June 2018 - August 2020',
      achievements: [
        'Programmed a software application for Aflac to securely manage intricate financial transactions',
        'Engineered front end components on Angular and back end API\'s on .Net core',
        'Implemented digital enrollment, payment flow using PayU payment gateway',
        'Resulted a 45% sales increase and 70% higher user turnout on the insurance portal',
        'Engineered back end API\'s , front end components on React js for an internal software application',
        'Achieved noteworthy 30% reduction in operational overhead for leadership to manage employee engagement, pay scales, contributions'
      ]
    }
  ];

  return (
    <section id="experience" className="experience-section">
      <Container maxWidth="lg">
        <Typography variant="h2" className="section-title" gutterBottom>
          Experience
        </Typography>
        <Box className="section-divider" />
        <Box className="experience-accordion-list">
          {experiences.map((exp, index) => (
            <Accordion key={index} className="experience-accordion" defaultExpanded={false}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                className="experience-summary"
              >
                <WorkIcon className="work-icon" />
                <Box className="experience-summary-content">
                  <Typography variant="h6" className="job-title">
                    {exp.title}
                  </Typography>
                  <Typography variant="body2" className="company-name">
                    {exp.company}
                  </Typography>
                  <Typography variant="caption" className="location-period">
                    {exp.location} • {exp.period}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails className="experience-details">
                <Box className="achievements-list">
                  {exp.achievements.map((achievement, idx) => (
                    <Box key={idx} className="achievement-item">
                      <Box className="bullet-point" />
                      <Typography variant="body2" className="achievement-text">
                        {achievement}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </section>
  );
};

export default Experience;
